import type { Mail } from '@/lib/data'
import { isCardArchived } from '@/lib/whatsapp-threads'

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/**
 * Lo que la pestana pide al servidor. Activas es "todo menos archivadas".
 *
 * Antes las pestanas filtraban en el navegador sobre las paginas cargadas:
 * con 34 archivadas y la primera en la pagina 8, Archivadas salia vacia y sin
 * filas no habia scroll con el que pedir mas.
 */
export function estadoDeLaPestana(pestana: 'active' | 'archived'): string {
  return pestana === 'archived' ? 'archived' : 'active,pending,needs_review,completed'
}

/**
 * Si un telefono coincide con lo tecleado, con o sin prefijo de pais.
 *
 * "+34 646 58 82 41", "646588241" y "34646588241" son el mismo numero. Se
 * comparan los ultimos 9 digitos, que es lo que tiene un movil espanol.
 */
export function telefonoCoincide(telefono: string, buscado: string): boolean {
  const a = telefono.replace(/\D/g, '')
  const b = buscado.replace(/\D/g, '')
  if (b.length < 4 || a.length < 4) return false
  return a.includes(b) || a.endsWith(b.slice(-9))
}

/**
 * Que filas de las cargadas se ensenan.
 *
 * Las conversaciones ya vienen filtradas del servidor (estado, canal y
 * busqueda), asi que aqui solo se filtra lo que el servidor no puede: las
 * llamadas, que se piden por otro endpoint sin busqueda. Filtrar tambien las
 * conversaciones por texto en cliente las escondia: el servidor busca en
 * cualquier mensaje y la tarjeta solo tiene el ultimo.
 */
export function filasVisibles(items: Mail[], activeTab: 'active' | 'archived', searchTerm: string): Mail[] {
  const termino = searchTerm.trim()
  const buscado = termino.toLowerCase()
  return items.filter((item) => {
    const pestana = isCardArchived(item) ? 'archived' : 'active'
    if (pestana !== activeTab) return false
    if (!termino) return true
    if (UUID.test(termino)) return item.id.toLowerCase() === buscado
    if (item.platform !== 'phone_call') return true
    return (
      item.subject.toLowerCase().includes(buscado) ||
      item.text.toLowerCase().includes(buscado) ||
      item.name.toLowerCase().includes(buscado) ||
      telefonoCoincide(item.phone ?? '', termino)
    )
  })
}
